import React, { useId, useState } from "react";
import { Icon } from "react-icons-kit";
import { ic_keyboard_arrow_down } from "react-icons-kit/md/ic_keyboard_arrow_down";
import { ic_keyboard_arrow_right } from "react-icons-kit/md/ic_keyboard_arrow_right";

export function CollapsibleSection({ title, defaultOpen, children, testId }: { title: string; defaultOpen: boolean; children: React.ReactNode; testId?: string }) {
    const [open, setOpen] = useState(defaultOpen);
    const contentId = useId();
    return (
        <div className={`rounded-lg border ${open ? "border-ui-cta-primary" : "border-ui-divider-lines"} overflow-hidden transition-colors`}>
            <button
                onClick={() => setOpen(!open)}
                className={`w-full flex items-center gap-2 px-4 py-3 text-sm font-semibold transition-colors ${open ? "bg-teal-t10 text-ui-cta-primary" : "bg-unlisted-very-light-gray text-ui-text-primary-text hover:text-ui-cta-primary"}`}
                type="button"
                aria-expanded={open}
                aria-controls={contentId}
                data-testid={testId}
            >
                <Icon icon={open ? ic_keyboard_arrow_down : ic_keyboard_arrow_right} size={20} />
                <span>{title}</span>
            </button>
            {open && <div id={contentId} className="bg-white">{children}</div>}
        </div>
    );
}
